import { cn } from "@omni/utils/styles";
import { ReactElement } from "react";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    boxLogisticInformation: string;
    shopName?: string;
};

const BoxPromise = ({
    shopName,
    boxLogisticInformation
}: Props): ReactElement => {
    const { t } = useGranite();
    return (
        <div className={cn("tw:mb-2")}>
            {shopName && (
                <div className={cn("tw:text-sm tw:font-bold")}>
                    {t("ecommerce.label.pickup.preferredStore", shopName)}
                </div>
            )}
            {!shopName && (
                <div className={cn("tw:text-sm")}>
                    {t("general.ecommerce.clickAndCollect.noStore")}
                </div>
            )}
            <div className={cn("tw:text-sm")}>
                <span>
                    <i className={cn("las la-check tw:mr-1")}></i>
                    {boxLogisticInformation}
                </span>
            </div>
        </div>
    );
};

export { BoxPromise };
